import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
// import './index.scss';
import App from './App';
import {AppHome} from "./App"
import reportWebVitals from './reportWebVitals';
import store,{persistor} from 'store';
import keycloak from 'Keycloak';
import { v4 as uuidv4 } from "uuid";
//import {studioGtmId } from 'utils/envsetup';
//import TagManager from 'react-gtm-module'
import { PersistGate } from 'redux-persist/integration/react'
// import {persistStore} from 'redux-persist'
// let persistor = persistStore(store)
import { BrowserRouter, useNavigate } from 'react-router-dom/dist';
import {logLevel} from 'utils/envsetup'
import CLogger from './logger/CLogger.js'
import '../node_modules/font-awesome/css/font-awesome.min.css'; 
const root = ReactDOM.createRoot(document.getElementById('root'));
const search = window.location.search;
const params = new URLSearchParams(search);

//console.log('params', params)
// const tagManagerArgs = {
//   gtmId: `${studioGtmId}`
// }

// TagManager.initialize(tagManagerArgs)
keycloak.init({ onLoad: 'check-sso', checkLoginIframe: false }).then(authenticated => {
  if (!authenticated) {
    const cLogger =CLogger({level:logLevel})
    // window.location.reload();
    // keycloak.login();
    cLogger.log('not auth');
    root.render(
      <Provider store={store}>
        {/* <PersistGate loading={null} persistor={persistor}> */}
        <AppHome/>
        {/* </PersistGate> */}
      </Provider>
    );
  } else {
    let uniqueId = localStorage.getItem('uniqueId')
    if (!uniqueId) {
      uniqueId = uuidv4();
      localStorage.setItem('uniqueId', uniqueId);
    }
    //       sessionStorage.setItem('authentication', keycloak.token);
    // sessionStorage.setItem('refreshToken', keycloak.refreshToken);
    // console.log('session', sessionStorage.getItem("authentication"))
    // console.log(
    //   'keycloak?.resourceAccess["realm-management"]?.roles',
    //   keycloak?.realmAccess?.roles,
    // );
    // if (!keycloak?.realmAccess?.roles?.includes('studio-user')) {
    //   console.log('Kandi user');
    //   window.alert('Not registered to Studio');
    //   keycloak.logout();
    // } else {
      root.render(
        <React.StrictMode>
          <Provider store={store}>
           <PersistGate loading={null} persistor={persistor}>
            <App params={params} query={search}/>
           </PersistGate> 
          </Provider>
        </React.StrictMode>,
      );
    // }
  }
}
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
